// extracted by mini-css-extract-plugin
module.exports = {"about-text":"index__about-text__18IzE","copyToClipboard":"index__copyToClipboard__1UYLM"};